import { render, staticRenderFns } from "./AddEditCustomQuestionTemplate.vue?vue&type=template&id=2d51982c&scoped=true"
import script from "./AddEditCustomQuestionTemplate.vue?vue&type=script&lang=js"
export * from "./AddEditCustomQuestionTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddEditCustomQuestionTemplate.vue?vue&type=style&index=0&id=2d51982c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51982c",
  null
  
)

export default component.exports